import { Autocomplete as NextUiAutocomplete } from "@nextui-org/react";
import { AutocompleteProps as NextUiAutocompleteProps } from "@nextui-org/react";
import styles from "./Autocomplete.module.scss";
import { ReactNode } from "react";
import InvalidIcon from "../../assets/images/icons/ui/states/alert-icon.svg";

interface AutocompleteProps extends NextUiAutocompleteProps {
  touched?: boolean;
  errorMessage?: ReactNode;
}

const Autocomplete = (props: AutocompleteProps) => {
  const { isInvalid, touched, errorMessage } = props;

  const { container, base, errorMessageContainer } = styles;

  return (
    <NextUiAutocomplete
      {...props}
      className={`${container}`}
      classNames={{
        base: base,
        ...props.classNames,
      }}
      errorMessage={
        isInvalid &&
        touched && (
          <div className={errorMessageContainer}>
            <img src={InvalidIcon} />
            {errorMessage ?? "Valor inválido"}
          </div>
        )
      }
    />
  );
};

export default Autocomplete;
